import { ChangeDetectorRef, Component, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScopeService } from 'app/layout/common/scope/scope.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Overlay } from 'ngx-toastr';
import { MyToastrService } from 'app/_services/toastr.service';
import { LoaderService } from 'app/_services/loader.service';
import { CommonService } from 'app/_services/common.service';
import { BaseRequestService } from 'app/_services/base.service';
import { UserService } from 'app/core/user/user.service';
import { Subject, takeUntil } from 'rxjs';
import { OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgFor, NgIf, NgOptimizedImage } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDrawer, MatSidenavModule } from "@angular/material/sidenav";
import * as _moment from "moment";
import { default as _rollupMoment, Moment } from "moment";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { ModalComponent } from "app/modules/shared/modal.component";
import { ModalService } from "app/_services/modal.service";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { fuseAnimations } from "@fuse/animations";
import { cloneDeep } from "lodash";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseAlertComponent, FuseAlertType } from "@fuse/components/alert";
import { environment } from 'environments/environment';


@Component({
  selector: 'app-summary',
  animations: fuseAnimations,
  standalone: true,
  imports: [
    CommonModule,
    GridsComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  summaryDeatils: any;
  distributor_id: any;
  loading: boolean = false;
  msspTableOptions: any;
  mssp_details: any = {
    tenant_name: null,
    email: null
  }
  alert: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: '',
  };
  showAlert = false;
  drawerPosition: "start" | "end" = "end";
  drawerMode: "over" | "side" = "over";
  drawerOpened: boolean = false;
  @ViewChild("drawer") drawer: MatDrawer;
  tenant_details: any = {};
  filtertext: any = '';
  objectKeys = Object.keys;
  show_popup = false;
  totalAssetsCount: number = 0;
  customersCount: number = 0;
  totalCompaniesCount: number = 0;
  totalLightWeightCount: number = 0;
  totalProbeCount: number = 0;
  totalExternalAssetCount: number = 0;
  tenantData: any;
  total_vul: any = 0;
  critical_vul: any = 0;
  high_vul: any = 0;
  medium_vul: any = 0;
  low_vul: any = 0;

  regions: any = [];
  signupConf: any = {
    title: 'Create New MSP',
    spanLayout: 2,
    showTopAlert: false,
    showBottomAlert: true,
    valuesoutput: {},
    formElements: [
      {
        "name": "email",
        "description": "Email",
        "example": "",
        "required": true,
        "schema": {
          "type": "email"
        }
      },
      {
        "name": "company",
        "description": "Company",
        "required": true,
        "schema": {
          "type": "text"
        }
      },
      {
        "name": "first_name",
        "description": "Firstname",
        "example": "",
        "required": true,
        "schema": {
          "type": "text"
        }
      },
      {
        "name": "last_name",
        "description": "Lastname",
        "example": "",
        "required": true,
        "schema": {
          "type": "text"
        }
      },
      {
        "name": "country",
        "description": "Choose Country",
        "example": "",
        "required": true,
        searching: true,
        "options": [{ "displayName": "Afghanistan" }, { "displayName": "Albania" }, { "displayName": "Algeria" }, { "displayName": "Andorra" }, { "displayName": "Angola" }, { "displayName": "Antigua and Barbuda" }, { "displayName": "Argentina" }, { "displayName": "Armenia" }, { "displayName": "Australia" }, { "displayName": "Austria" }, { "displayName": "Azerbaijan" }, { "displayName": "Bahamas" }, { "displayName": "Bahrain" }, { "displayName": "Bangladesh" }, { "displayName": "Barbados" }, { "displayName": "Belarus" }, { "displayName": "Belgium" }, { "displayName": "Belize" }, { "displayName": "Benin" }, { "displayName": "Bhutan" }, { "displayName": "Bolivia" }, { "displayName": "Bosnia and Herzegovina" }, { "displayName": "Botswana" }, { "displayName": "Brazil" }, { "displayName": "Brunei" }, { "displayName": "Bulgaria" }, { "displayName": "Burkina Faso" }, { "displayName": "Burundi" }, { "displayName": "Cote dIvoire" }, { "displayName": "Cabo Verde" }, { "displayName": "Cambodia" }, { "displayName": "Cameroon" }, { "displayName": "Canada" }, { "displayName": "Central African Republic" }, { "displayName": "Chad" }, { "displayName": "Chile" }, { "displayName": "China" }, { "displayName": "Colombia" }, { "displayName": "Comoros" }, { "displayName": "Congo (Congo-Brazzaville)" }, { "displayName": "Costa Rica" }, { "displayName": "Croatia" }, { "displayName": "Cuba" }, { "displayName": "Cyprus" }, { "displayName": "Czechia (Czech Republic)" }, { "displayName": "Democratic Republic of the Congo" }, { "displayName": "Denmark" }, { "displayName": "Djibouti" }, { "displayName": "Dominica" }, { "displayName": "Dominican Republic" }, { "displayName": "Ecuador" }, { "displayName": "Egypt" }, { "displayName": "El Salvador" }, { "displayName": "Equatorial Guinea" }, { "displayName": "Eritrea" }, { "displayName": "Estonia" }, { "displayName": "Eswatini (fmr. \"Swaziland\")" }, { "displayName": "Ethiopia" }, { "displayName": "Fiji" }, { "displayName": "Finland" }, { "displayName": "France" }, { "displayName": "Gabon" }, { "displayName": "Gambia" }, { "displayName": "Georgia" }, { "displayName": "Germany" }, { "displayName": "Ghana" }, { "displayName": "Greece" }, { "displayName": "Grenada" }, { "displayName": "Guatemala" }, { "displayName": "Guinea" }, { "displayName": "Guinea-Bissau" }, { "displayName": "Guyana" }, { "displayName": "Haiti" }, { "displayName": "Holy See" }, { "displayName": "Honduras" }, { "displayName": "Hungary" }, { "displayName": "Iceland" }, { "displayName": "India" }, { "displayName": "Indonesia" }, { "displayName": "Iran" }, { "displayName": "Iraq" }, { "displayName": "Ireland" }, { "displayName": "Israel" }, { "displayName": "Italy" }, { "displayName": "Jamaica" }, { "displayName": "Japan" }, { "displayName": "Jordan" }, { "displayName": "Kazakhstan" }, { "displayName": "Kenya" }, { "displayName": "Kiribati" }, { "displayName": "Kuwait" }, { "displayName": "Kyrgyzstan" }, { "displayName": "Laos" }, { "displayName": "Latvia" }, { "displayName": "Lebanon" }, { "displayName": "Lesotho" }, { "displayName": "Liberia" }, { "displayName": "Libya" }, { "displayName": "Liechtenstein" }, { "displayName": "Lithuania" }, { "displayName": "Luxembourg" }, { "displayName": "Madagascar" }, { "displayName": "Malawi" }, { "displayName": "Malaysia" }, { "displayName": "Maldives" }, { "displayName": "Mali" }, { "displayName": "Malta" }, { "displayName": "Marshall Islands" }, { "displayName": "Mauritania" }, { "displayName": "Mauritius" }, { "displayName": "Mexico" }, { "displayName": "Micronesia" }, { "displayName": "Moldova" }, { "displayName": "Monaco" }, { "displayName": "Mongolia" }, { "displayName": "Montenegro" }, { "displayName": "Morocco" }, { "displayName": "Mozambique" }, { "displayName": "Myanmar (formerly Burma)" }, { "displayName": "Namibia" }, { "displayName": "Nauru" }, { "displayName": "Nepal" }, { "displayName": "Netherlands" }, { "displayName": "New Zealand" }, { "displayName": "Nicaragua" }, { "displayName": "Niger" }, { "displayName": "Nigeria" }, { "displayName": "North Korea" }, { "displayName": "North Macedonia" }, { "displayName": "Norway" }, { "displayName": "Oman" }, { "displayName": "Pakistan" }, { "displayName": "Palau" }, { "displayName": "Palestine State" }, { "displayName": "Panama" }, { "displayName": "Papua New Guinea" }, { "displayName": "Paraguay" }, { "displayName": "Peru" }, { "displayName": "Philippines" }, { "displayName": "Poland" }, { "displayName": "Portugal" }, { "displayName": "Qatar" }, { "displayName": "Romania" }, { "displayName": "Russia" }, { "displayName": "Rwanda" }, { "displayName": "Saint Kitts and Nevis" }, { "displayName": "Saint Lucia" }, { "displayName": "Saint Vincent and the Grenadines" }, { "displayName": "Samoa" }, { "displayName": "San Marino" }, { "displayName": "Sao Tome and Principe" }, { "displayName": "Saudi Arabia" }, { "displayName": "Senegal" }, { "displayName": "Serbia" }, { "displayName": "Seychelles" }, { "displayName": "Sierra Leone" }, { "displayName": "Singapore" }, { "displayName": "Slovakia" }, { "displayName": "Slovenia" }, { "displayName": "Solomon Islands" }, { "displayName": "Somalia" }, { "displayName": "South Africa" }, { "displayName": "South Korea" }, { "displayName": "South Sudan" }, { "displayName": "Spain" }, { "displayName": "Sri Lanka" }, { "displayName": "Sudan" }, { "displayName": "Suriname" }, { "displayName": "Sweden" }, { "displayName": "Switzerland" }, { "displayName": "Syria" }, { "displayName": "Tajikistan" }, { "displayName": "Tanzania" }, { "displayName": "Thailand" }, { "displayName": "Timor-Leste" }, { "displayName": "Togo" }, { "displayName": "Tonga" }, { "displayName": "Trinidad and Tobago" }, { "displayName": "Tunisia" }, { "displayName": "Turkey" }, { "displayName": "Turkmenistan" }, { "displayName": "Tuvalu" }, { "displayName": "Uganda" }, { "displayName": "Ukraine" }, { "displayName": "United Arab Emirates" }, { "displayName": "United Kingdom" }, { "displayName": "United States of America" }, { "displayName": "Uruguay" }, { "displayName": "Uzbekistan" }, { "displayName": "Vanuatu" }, { "displayName": "Venezuela" }, { "displayName": "Vietnam" }, { "displayName": "Yemen" }, { "displayName": "Zambia" }, { "displayName": "Zimbabwe" }],
        "schema": {
          "type": "dropdown",
          "key": "displayName",
          "value": "displayName",
        }
      },
      {
        "name": "city",
        "description": "City",
        "example": "",
        "required": true,
        "schema": {
          "type": "text"
        }
      },
      {
        "name": "state",
        "description": "State",
        "example": "",
        "required": true,
        "schema": {
          "type": "text"
        }
      },
      {
        "name": "mobile",
        "description": "Mobile",
        "example": "",
        "max": 10,
        "min": 10,
        "required": true,
        "schema": {
          "type": "number"
        }
      },
      {
        "name": "region",
        "description": "Choose Region",
        "example": "",
        "required": true,
        "options": [],
        "schema": {
          "type": "dropdown",
          "key": "displayName",
          "value": "name",
        }
      },
      {
        "name": "tenant_name",
        "description": "Tenant Name",
        "example": "No special letters",
        "required": true,
        "min": 3,
        "max": 63,
        "schema": {
          "type": "text"
        }
      },
      {
        "name": "tokenControl",
        "description": "",
        "required": false,
        "schema": {
          "type": "s_captcha"
        }
      },
    ],
    token: 'nklYPAPFSkj6oz9weitIME_1oP-TVkOEZDEkK9LmSV5-mKbJnc2SfbOKFqyfP-rYFW4ay9s',
    url: '/w/mssp/sign_up',
    redirectRouterLink: '/sign-in',
    passLength: 8,
    fnBtnName: 'Submit',
    closeBtnName: 'Close',
    objectMapping: [
      { "source": "email", "destination": "email" },
      { "source": "company", "destination": "company" },
      { "source": "first_name", "destination": "first_name" },
      { "source": "last_name", "destination": "last_name" },
      { "source": "password", "destination": "password" },
      { "source": "city", "destination": "city" },
      { "source": "state", "destination": "state" },
      { "source": "country", "destination": "country" },
      { "source": "mobile", "destination": "mobile" },
      { "source": "region", "destination": "region" },
      { "source": "tenant_name", "destination": "tenant_name" }
    ],
    isComponentSide: true,
  }
  regionHash: any = {};
  elementList: any = [];
  constructor(
    private _changeDetectorRef: ChangeDetectorRef, private toast: MyToastrService, private _router: Router,
    public cs: CommonService, private loaderService: LoaderService, public _modalService: ModalService,
    public _bs: BaseRequestService, public _us: UserService, public confirmDialog: FuseConfirmationService
  ) {
    this.cs.selectedSiteChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res) => {
        if (this.drawer && this.drawer.opened) { this.drawer.toggle().then((r) => console.log(r)); }
        if (this.cs.currentScope !== '*') {
          localStorage.setItem('isNew', 'yes');
          this.msspTableOptions = {}; this._changeDetectorRef.detectChanges();
          this._router.navigateByUrl(`/overview/mssp/${this.cs.currentScope.tenant_id}`);
        } else {
          this.getMSSPs();
          this.getMSSPsCount();
        }

      });
  }

  ngOnInit(): void {
    if (this.cs.currentScope !== '*') {
      localStorage.setItem('isNew', 'yes');
      this._router.navigateByUrl(`/overview/mssp/${this.cs.currentScope.tenant_id}`);
    } else {
      this.showAlert = false;
      this.getMSSPs();
      this.getMSSPsCount();
      this.getRegions();

    }
  }

  getRegions(): void {
    this._bs.doRequest('https://configuration.myconnectsecure.com/api/getRegions', 'get')
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.signupConf.formElements.forEach((obj: any) => {
            if (obj.name === 'region') {
              obj.options = result.message;
            }
          });
          this.regions = result.message;
        } else {
          console.log("Error in getRegions");
        }
      });
  }

  getMSSPsCount(): void {
    let totalCritical = 0;
    let totalHigh = 0;
    let totalMedium = 0;
    let totalLow = 0;
    this.customersCount = 0;
    this.totalCompaniesCount = 0; this.totalAssetsCount = 0; this.totalLightWeightCount = 0;
    this.totalProbeCount = 0; this.totalExternalAssetCount = 0; this.critical_vul = 0;
    this.high_vul = 0; this.medium_vul = 0; this.low_vul = 0; this.total_vul = 0;
    this.tenantData = [];
    this.customersCount = this.cs.allMssps.length;
    for (const tenant of this.cs.allMssps) {
      this.totalCompaniesCount += tenant.companies || 0;
      this.totalAssetsCount += tenant.assets || 0;
      this.totalLightWeightCount += tenant.light_weight_agent || 0;
      this.totalProbeCount += tenant.probe || 0;
      this.totalExternalAssetCount += tenant.external || 0;
      totalCritical += (tenant.vul_stats && this.objectKeys(tenant.vul_stats).length) ? tenant.vul_stats.critical : 0;
      totalHigh += (tenant.vul_stats && this.objectKeys(tenant.vul_stats).length) ? tenant.vul_stats.high : 0;
      totalMedium += (tenant.vul_stats && this.objectKeys(tenant.vul_stats).length) ? tenant.vul_stats.medium : 0;
      totalLow += (tenant.vul_stats && this.objectKeys(tenant.vul_stats).length) ? tenant.vul_stats.low : 0;
    }

    // Calculate the overall total
    const totalVulnerabilities = totalCritical + totalHigh + totalMedium + totalLow;
    // Calculate averages
    const numberOfTenants = this.cs.allMssps.length;
    this.critical_vul = (numberOfTenants) ? Math.round(totalCritical / numberOfTenants) : 0;
    this.high_vul = (numberOfTenants) ? Math.round(totalHigh / numberOfTenants) : 0;
    this.medium_vul = (numberOfTenants) ? Math.round(totalMedium / numberOfTenants) : 0;
    this.low_vul = (numberOfTenants) ? Math.round(totalLow / numberOfTenants) : 0;
    this.total_vul = (numberOfTenants) ? Math.round(totalVulnerabilities / numberOfTenants) : 0;
    this.tenantData = this.cs.allMssps;
    this._changeDetectorRef.detectChanges();
  }

  getMSSPs(): void {
    const response: any = {
      columns: [
        {
          header: "First Name",
          columnDef: "first_name",
          cType: "string",
          filter: "",
          cell: "(element: any) => `${element.first_name}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          class: "",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          header: "Last Name",
          columnDef: "last_name",
          cType: "string",
          filter: "",
          cell: "(element: any) => `${element.last_name}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          class: "",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          header: "Tenant Name",
          columnDef: "tenant_name",
          cType: "string",
          filter: "",
          cell: "(element: any) => `${element.tenant_name}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          isHyperlink: true,
          class: "",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
          actionConditions: { key: 'mssp_request_status' },
          allowedCondition: ['Approved'],
        },
        {
          header: "Tenant Admin",
          columnDef: "email",
          cType: "string",
          filter: "",
          cell: "(element: any) => `${element.email}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          class: "",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          header: "Requested To",
          columnDef: "mssp_requested_email",
          cType: "string",
          filter: "",
          cell: "(element: any) => `${element.mssp_requested_email}`",
          order: 0,
          visible: true,
          // align: "center",
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          class: "",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
          isNA: true
        },
        {
          header: "Approved/Rejected By",
          columnDef: "mssp_approval_email",
          cType: "string",
          filter: "",
          cell: "(element: any) => `${element.mssp_approval_email}`",
          order: 0,
          // align: "center",
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          class: "",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
          isNA: true
        },
        {
          header: "Companies",
          columnDef: "companies",
          cType: "number",
          filter: "",
          cell: "(element: any) => `${element.companies}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          isClass: true,
          "class": "bg-teal-600 text-white",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          header: "Lightweight Agents",
          columnDef: "light_weight_agent",
          cType: "number",
          filter: "",
          cell: "(element: any) => `${element.light_weight_agent}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          isClass: true,
          "class": "bg-teal-600 text-white",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          header: "Probe Agents",
          columnDef: "probe",
          cType: "number",
          filter: "",
          cell: "(element: any) => `${element.probe}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          isClass: true,
          "class": "bg-teal-600 text-white",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          // header: "Probe Discovered Assets",
          header: "Probe Assets", 
          columnDef: "assets",
          cType: "number",
          filter: "",
          cell: "(element: any) => `${element.assets}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          isClass: true,
          "class": "bg-teal-600 text-white",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          header: "External Assets",
          columnDef: "external",
          cType: "number",
          filter: "",
          cell: "(element: any) => `${element.external}`",
          order: 0,
          visible: true,
          isToolTip: false,
          isToolTipCol: "",
          hasMultiData: false,
          isClass: true,
          "class": "bg-teal-600 text-white",
          color: "",
          isProgressCntrl: false,
          isColoredCntrl: false,
          colList: [],
          isfaicon: false,
          isAddingText: false,
          addingText: "",
          img: false,
          imgPath: "",
          isSort: true,
          iscolumnSearch: false,
        },
        {
          "header": "Total Vulnerabilities",
          cType: "number",
          width: 'w-[80px]',
          "columnDef": "total_vul",
          "filter": "",
          "cell": "(element: any) => `${element.total_vul}`",
          "order": 0,
          "visible": true,
          "isToolTip": false,
          "isToolTipCol": "",
          "hasMultiData": false,
          isClass: true,
          "class": "dark:bg-blue-600 bg-blue-500 text-white",
          "color": "",
          "isProgressCntrl": false,
          isColoredCntrl: false,
          isCustomText: false,
          "colList": [],
          "isfaicon": false,
          "isAddingText": false,
          "addingText": "",
          "img": false,
          "imgPath": "",
          "isSort": true,
          "iscolumnSearch": false
        },
        {
          "header": "Critical",
          cType: "number",
          width: 'w-[80px]',
          "columnDef": "critical_vul",
          "customFilter": "",
          "cell": "(element: any) => `${element.critical_vul}`",
          "visible": true,
          order: 0,
          "isToolTip": false,
          "isToolTipCol": "",
          "hasMultiData": false,
          isClass: true,
          "class": "cs-critical",
          "color": "",
          "isProgressCntrl": false,
          isColoredCntrl: false,
          isCustomText: false,
          isCusHyperlink: true,
          "colList": [],
          "isfaicon": false,
          "isAddingText": false,
          "addingText": "",
          "img": false,
          "imgPath": "",
          "isSort": true,
          "iscolumnSearch": false
        },
        {
          "header": "High",
          cType: "number",
          width: 'w-[80px]',
          "columnDef": "high_vul",
          "filter": "",
          "cell": "(element: any) => `${element.high_vul}`",
          "order": 0,
          "visible": true,
          "isToolTip": false,
          "isToolTipCol": "",
          "hasMultiData": false,
          isClass: true,
          "class": "cs-high",
          "color": "",
          "isProgressCntrl": false,
          isColoredCntrl: false,
          isCustomText: false,
          isCusHyperlink: true,
          "colList": [],
          "isfaicon": false,
          "isAddingText": false,
          "addingText": "",
          "img": false,
          "imgPath": "",
          "isSort": true,
          "iscolumnSearch": false
        },
        {
          "header": "Medium",
          cType: "number",
          width: 'w-[80px]',
          "columnDef": "medium_vul",
          "filter": "",
          "cell": "(element: any) => `${element.medium_vul}`",
          "order": 0,
          "visible": true,
          "isToolTip": false,
          "isToolTipCol": "",
          "hasMultiData": false,
          isClass: true,
          "class": "cs-medium",
          "color": "",
          "isProgressCntrl": false,
          isColoredCntrl: false,
          isCustomText: false,
          isCusHyperlink: true,
          "colList": [],
          "isfaicon": false,
          "isAddingText": false,
          "addingText": "",
          "img": false,
          "imgPath": "",
          "isSort": true,
          "iscolumnSearch": false
        },
        {
          "header": "Low",
          cType: "number",
          width: 'w-[80px]',
          "columnDef": "low_vul",
          "filter": "",
          "cell": "(element: any) => `${element.low_vul}`",
          "order": 0,
          "visible": true,
          "isToolTip": false,
          "isToolTipCol": "",
          "hasMultiData": false,
          isClass: true,
          "class": "cs-low",
          "color": "",
          "isProgressCntrl": false,
          isColoredCntrl: false,
          isCustomText: false,
          isCusHyperlink: true,
          "colList": [],
          "isfaicon": false,
          "isAddingText": false,
          "addingText": "",
          "img": false,
          "imgPath": "",
          "isSort": true,
          "iscolumnSearch": false
        },
        {
          "header": "Request Status",
          "columnDef": "mssp_request_status",
          "cType": "string",
          "width":'170px',
          "filter": "",
          "cell": "(element: any) => ${element.mssp_request_status}",
          isColoredCntrl: true,
          isCustomClass: true,
          isCustomText: true,
          "order": 0,
          "visible": true,
          "isToolTip": false,
          "isToolTipCol": "",
          "hasMultiData": false,
          "class": "",
          "color": "",
          "isProgressCntrl": false,
          "colList": [],
          "isfaicon": false,
          "isAddingText": false,
          "addingText": "",
          "img": false,
          "imgPath": "",
          "isSort": true,
          "iscolumnSearch": false,
        },

      ],
      sortOptions: { active: "updated", direction: "asc" },
      _pageData: [],
      tableOptions: {
        title: "MSPs",
        isServerSide: false,
        selectText: "MSP(s)",
        loading: true,
        floatingFilter: true,
        rowSelection: false,
        showAction: true,
        isSettingCalled: true,
        customPagination: true,
        isDefaultSearch: true,
        isHideGlobal: true,
        actionMenuItems: [
          {
            text: "Details",
            id: "details",
            icon: "mat_outline:details",
            callback: "timeFunc",
            isGlobal: false,
            actionConditions: { key: 'mssp_request_status' },
            allowedCondition: ['Approved'],
          },
          {
            text: 'Remove',
            id: 'delete',
            icon: 'delete',
            callback: 'deleteFunction',
            isGlobal: true,
          }
        ],
        pagination: true,
        pageOptions: [5, 10, 25, 100],
        pageSize: 10,
        search: false,
        saveData: true,
        showhideList: true,
        hideDownload: true,
        refreshData: true,
        showFilter: false,
        showTagFilter: false,
        exportExcel: true,
        apiDownload: true,
        add: true, addText: 'Link MSP',
        cusadd: true, addCusText: 'Create New MSP',
        columnSearch: false,
        compareData: false,
        filterDownload: false,
        dataMapping: [
          { s: 'vul_stats', d: 'total_problems', filter: 'statstovuls:total' },
          { s: 'vul_stats', d: 'critical_problems', filter: 'statstovuls:critical' },
          { s: 'vul_stats', d: 'high_problems', filter: 'statstovuls:high' },
          { s: 'vul_stats', d: 'medium_problems', filter: 'statstovuls:medium' },
          { s: 'vul_stats', d: 'low_problems', filter: 'statstovuls:low' },
        ],
        serverSide: {
          url: "/r/report_queries/list_msp",
          condition: true,
          type: "get",
        },
      },
      customText: [
        {
          status: 'Pending Approval',
          DisplayText: 'Pending Approval',
          class: 'bg-blue-500 text-blue-50 dark:bg-blue-600 dark:text-blue-50'
        },
        {
          status: 'Approved',
          DisplayText: 'Approved',
          class: 'bg-green-500 text-green-50 dark:bg-green-600 dark:text-green-50'
        },
        {
          status: 'Rejected',
          DisplayText: 'Rejected',
          class: 'bg-red-500 text-red-800 dark:bg-red-600 dark:text-red-50'
        },
      ],
      changeValue: new Subject<any>(),
    };
    let data = Object.assign({}, response);
    this.msspTableOptions = {}; this._changeDetectorRef.detectChanges();
    data.pageData = []; data.tableOptions.pageTotal = 0;
    this.msspTableOptions = data; this._changeDetectorRef.detectChanges();
  }

  close(): void {
    this._modalService.close('createMsspModal');
  }


apiDataDownload(): void {
  this.loaderService.display(true);
  this._bs.doRequest('/r/mssp/generate_msp_report', 'get', null, { tenant_id: 'global' })
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(
          (result: any) => {
              this.loaderService.display(false);
              if (result.status) {
                  window.open(result.url, '_blank');
              } else {
                  const data = result.message;
                  this.toast.sToast('error', data);
              }
          },
          (error: any) => {
              this.loaderService.display(false);
              this.toast.sToast('error', 'An error occurred while downloading the data.');
              console.error('API Error:', error); // Log the error for debugging
          }
      );
}

  signup($event: any): void {
    this.showAlert = false;
    if ($event.tenant_name && $event.tenant_name.indexOf('_') > -1 || $event.tenant_name.indexOf('.') > -1) {
      this.showAlert = true; this.alert.type = 'error'; this.alert.message = 'The tenant name should not contain any special letters. Please use alpha numeric';
      return;
    }
    const data: any = {};
    this.signupConf.objectMapping.forEach((a: any) => {
      data[a.destination] = $event[a.source];
    });
    const postData = (this.signupConf.objectMapping && this.signupConf.objectMapping.length) ? data : $event;
    postData.tokenControl = $event.tokenControl;
    if (!environment.production) {
      postData.region = 'ap-south-2';
    }
    this.loaderService.display(true);
    this._bs.doRequest(this.signupConf.url, 'post', postData)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this._modalService.close('createMsspModal');
          this.show_popup = true;
        } else {
          const data = (result.message) ? result.message : result.data;
          this.toast.sToast('error', data);
        }
      }, (error: any) => {
        this.loaderService.display(false);
        const data = (error.message) ? error.message : error.data;
        this.toast.sToast('error', data);
      });
  }
  addCall(event: any): void {
    if (event) {
      if (!this.signupConf.spanLayout) {
        this.signupConf.spanLayout = 1;
      }
      this.elementList = this.cs.processFormElements(this.signupConf.formElements);
      this.signupConf.valuesoutput = {};
      if (this.regions && this.regions.length) {
        this.regions.forEach((obj: any) => {
          this.regionHash[obj.name] = obj.value;
        });
      }
      this.show_popup = false;
      this._modalService.open('createMsspModal');
    } else {
      this.mssp_details = { tenant_name: null, email: null };
      this._modalService.open('addMsspModal');
    }
  }

  async SaveMSSP() {
    this.showAlert = false;
    const request = cloneDeep(this.mssp_details);
    if (request.tenant_name && request.tenant_name.indexOf('_') > -1 || request.tenant_name.indexOf('.') > -1) {
      this.showAlert = true;
      this.alert.type = 'error';
      this.alert.message = 'The tenant name should not contain any special letters. Please use alpha numeric';
      return;
    }
    try {
      const response = await this._bs.doRequest("/w/mssp/add_msp", "post", request).toPromise();
      if (response.status) {
        this._modalService.close('addMsspModal');
        const data = (response.message) ? response.message : response.data;
        this.toast.sToast('success', data);
        this.getMSSPs();
        this.cs.newCompanyCall.emit({});
      } else {
        const data = (response.message) ? response.message : response.data;
        this.toast.sToast('error', data);
      }

    } catch (error) {
      // Handle errors here
      throw error;
    }
  }

  linkClick(event: any): void {
    if (event.col === 'tenant_name') {
      const url = `${environment.tenantURL}?tenant_name=${event.row.tenant_name}`
      window.open(url, "_blank");
    }
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
    
  actionCall(event: any): void {
    if (event.action.text === "Details") {
      this.tenantDetails(event.row)
    }
    if (event.action.text === "Remove") {
      this.removeTenant(event.row)
    }
  }

  async tenantDetails(data: any) {
    const request = { tenant_id: data.tenant_id };
    try {
      this.loaderService.display(true);
      this.tenant_details = {};
      const response = await this._bs.doRequest("/r/mssp/msp_detail_view", "get", null, request).toPromise();
      if (response.status) {
        this.loaderService.display(false);
        if(!response.data || !response.data.length){
          this.toast.sToast('info', 'Currently Data is not Available');
        }
        this.tenant_details = {
          tenant_name: data.tenant_name,
          details: response.data[0].details
        }
        console.log(this.tenant_details);
        this._changeDetectorRef.detectChanges();
        this.drawerOpened = true;
        if (!this.drawer.opened) {
          this.drawer.toggle().then((r) => console.log(r));
        }
      } else {
        this.loaderService.display(false);
        const data = (response.message) ? response.message : response.data;
        this.toast.sToast('error', data);
      }
    } catch (error) {
      // Handle errors here
      throw error;
    }
  }

  async removeTenant(data: any): Promise<any> {
    const confirmation = this.confirmDialog.open({
      title: 'Confirmation',
      message: `Are you sure you want to remove this tenant "${data.tenant_name}"?`,
      icon: {
        show: true,
        name: 'heroicons_outline:information-circle',
        color: 'primary'
      },
      actions: {
        confirm: {
          label: 'Yes',
          color: "primary"
        }
      }
    });
    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        const request = { tenant_id: data.tenant_id };
        this.loaderService.display(true);
        this._bs.doRequest('/w/mssp/remove_msp', 'post', request)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            this.loaderService.display(false);
            if (result.status) {
              this.toast.sToast('success', `Tenant ${data.tenant_name} removed successfully`);
              this.getMSSPs();
              this.cs.newCompanyCall.emit({});
            } else {
              const data = (result.message) ? result.message : result.data;
              this.toast.sToast('error', data);
            }
          });
      }
    })
  }
}
